import { render, staticRenderFns } from "./CreateFromDraft.vue?vue&type=template&id=6cbefddf&scoped=true&"
import script from "./CreateFromDraft.vue?vue&type=script&lang=js&"
export * from "./CreateFromDraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbefddf",
  null
  
)

export default component.exports